// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2ySv9","calendarButtons":"ClockData_calendarButtons__237V2"};